export default __webpack_public_path__ + "static/media/graxalta_GxD_png_cleanlogo_01.212fd3e5.jpg";